"use client";

import authSettings from "@/shared/config/authSettings";
import { PublicActionButton } from "@/shared/public-ui";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import type { GenericIconType } from "@/shared/ui/actions/GenericIcon";
import useBrowserAuthSession from "./useBrowserAuthSession";

type ProfileYourselfButtonProps = {
  href: string;
  icon?: GenericIconType;
  label: string;
  tone: "primary";
};

export default function ProfileYourselfButton({
  href: publicHref,
  icon,
  label,
  tone,
}: ProfileYourselfButtonProps) {
  const isAuthenticated = useBrowserAuthSession();
  const href = isAuthenticated ? authSettings.redirects.privateHome : publicHref;

  return (
    <PublicActionButton
      asChild
      size={{
        base: "md",
        md: "lg",
      }}
      tone={tone}
    >
      <a href={href}>
        {icon ? <GenericIcon icon={icon} /> : null}
        {isAuthenticated ? "Open app" : label}
      </a>
    </PublicActionButton>
  );
}
